import ResetEmail from 'modules/auth/containers/ResetEmail';
import React from 'react';

const ResetPasswordPage = (props) => {
  return <ResetEmail {...props} />;
};

export default ResetPasswordPage;
